



























import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import {
  GetExecuteEducationList,
  DeleteEducation
} from "@/api/pdOutPatient/pdEducation/pdExecuteEducation";
import PdExecuteEducationPlay from "./pdExecuteEducationPlay.vue";
@Component({
  components: {
    PdExecuteEducationPlay
  }
})
export default class PdExecuteEducation extends AbpBase {
  @Prop() patient: any;
  showAddExecuteEducation: boolean = false;
  loading: boolean = false;
  ExecuteEducationList: any[] = [];
  pdExecuteEducation: any = {};
  ExecuteKnowledge = [
    {
      title: "推荐材料",
      key: "name"
    },
    {
      title: "推荐时间",
      key: "tjrq",
      render: (h: any, p: any) => {
        return h("span", {}, this.formatDateTime(p.row.tjrq));
      }
    },
    {
      title: "推荐医生",
      key: "tjr"
    },
    {
      title: "操作",
      key: "",
      render: (h: any, p: any) => {
        return h("div", [
          h("Button", {
            props: { type: "success", icon: "ios-videocam", size: "small" },
            style: { marginRight: "5px" },
            on: {
              click: () => {
                this.onExecuteEducationPlay(p.row);
              }
            }
          }),
          h("Button", {
            props: { type: "error", icon: "ios-trash", size: "small" },
            style: { marginRight: "5px" },
            on: {
              click: () => {
                this.onEducationDelete(p.row.id);
              }
            }
          })
        ]);
      }
    }
  ];

  @Watch("patient", { immediate: false, deep: true })
  async getData() {
    this.loading = true;
    this.pdExecuteEducation = {};
    var res = await GetExecuteEducationList(this.patient.pD_Patient_ID);
    this.ExecuteEducationList = res.objects;
    this.loading = false;
  }

  //播放
  onExecuteEducationPlay(data: any) {
    this.pdExecuteEducation = data;
    this.showAddExecuteEducation = true;
  }

  //新增宣教情况
  onAddPdExecuteEducationOK() {
    this.loading = true;
    this.$refs.PdExecuteEducationPlay.submit().then(res => {
      if (res) {
        this.showAddExecuteEducation = false;
        this.getData();
      }
    });
    this.loading = false;
  }

  //删除宣教任务
  onEducationDelete(id: any) {
    this.$confirm("确定要删除吗？", "提示").then(() => {
      this.loading = true;
      DeleteEducation(id).then(res => {
        this.getData();
      });
      this.loading = false;
    });
  }
  constructor() {
    super();
    this.getData();
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/pdOutPatient/pdEducation/pdExecuteEducation/index.vue